/** Textes « parametres » — le français fait foi. */
export const parametres = {
  titre: 'Paramètres',
  reserve: 'Réservé au gérant · finances',
  lectureSeule: 'Lecture seule',
  onglets: { agence: 'Agence', regles: 'Règles du contrat', supplements: 'Suppléments', cgl: 'Conditions générales' },
  enregistre: 'Enregistré.',
  enregistreRecharger: 'Enregistré. La langue, la devise et les formats s\'appliqueront au prochain rechargement de la page.',
  erreur: 'Erreur',
  suppMisAJour: (l: string) => `« ${l} » mis à jour.`,
  arManquantTitre: (n: number) => `${n} article(s) sans texte arabe`,
  arManquantTexte: 'Le contrat imprime sort déjà en deux colonnes, mais les corps de texte arabes doivent être colles depuis votre document existant.',
  lesCompleter: 'Les compléter',
  intl: {
    titre: 'Pays, langue et formats',
    pays: 'Pays de l\'agence',
    paysAide: 'Sert aux identifiants légaux proposés et au vocabulaire (wilayas en Algérie).',
    locale: 'Langue et formats par défaut',
    localeAide: 'Langue de l\'interface pour qui n\'a rien choisi, et format des dates et des nombres.',
    fuseau: 'Fuseau horaire',
    fuseauAide: 'Les journées de caisse et les échéances suivent cette heure.',
    fuseauFiltre: 'Filtrer les fuseaux…',
    devise: 'Devise de référence',
    deviseAide: 'Code ISO à trois lettres (DZD, EUR, GBP, USD, CAD, AUD…).',
    unite: 'Unité de distance',
    uniteKm: 'Kilomètres (km)',
    uniteMi: 'Miles (mi)',
    nomTaxe: 'Nom de la taxe',
    nomTaxeAide: 'Imprimé sur les factures : TVA, VAT, GST, Sales tax, IVA, MwSt…',
    tauxTaxe: 'Taux de taxe (%)',
    taxeParDefaut: 'Cocher la taxe par défaut sur les nouvelles locations',
    langueDocs: 'Langue des documents',
    langueDocsAide: 'Langue principale des contrats et des factures imprimés.',
    langueDocs2: 'Deuxième langue des documents',
    langueDocs2Aide: 'Imprimée en seconde colonne. « Aucune » pour un document dans une seule langue.',
    aucune: 'Aucune',
    langues: { fr: 'Français', en: 'Anglais', ar: 'Arabe' } as Record<string, string>,
    identifiants: 'Identifiants légaux imprimés sur les documents',
    identifiantsAide: 'Jusqu\'à 8 lignes. Liste vide : les documents impriment les champs algériens (RC, NIF, NIS, article d\'imposition) de l\'onglet Agence.',
    libelle: 'Libellé',
    valeur: 'Valeur',
    ajouterIdentifiant: 'Ajouter un identifiant',
    retirer: 'Retirer',
    preremplir: (pays: string) => `Préremplir pour ${pays}`,
    remplacerIdentifiants: 'Remplacer les identifiants déjà saisis par ceux de ce pays ?',
    rechargement: 'La langue, la devise et les formats sont lus au démarrage : ils s\'appliquent au prochain rechargement de la page.',
    enregistrer: 'Enregistrer pays, langue et formats',
  },
  pays: {
    DZ: 'Algérie', FR: 'France', BE: 'Belgique', CH: 'Suisse', CA: 'Canada', GB: 'Royaume-Uni',
    IE: 'Irlande', US: 'États-Unis', AU: 'Australie', NZ: 'Nouvelle-Zélande', MA: 'Maroc',
    TN: 'Tunisie', ES: 'Espagne', PT: 'Portugal',
  } as Record<string, string>,
  locales: {
    'fr-DZ': 'Français (Algérie)', 'fr-FR': 'Français (France)', 'fr-BE': 'Français (Belgique)',
    'fr-CH': 'Français (Suisse)', 'fr-CA': 'Français (Canada)', 'fr-MA': 'Français (Maroc)', 'fr-TN': 'Français (Tunisie)',
    'en-GB': 'Anglais (Royaume-Uni)', 'en-IE': 'Anglais (Irlande)', 'en-US': 'Anglais (États-Unis)',
    'en-AU': 'Anglais (Australie)', 'en-CA': 'Anglais (Canada)', 'en-NZ': 'Anglais (Nouvelle-Zélande)',
  } as Record<string, string>,
  identite: 'Identité imprimée sur vos documents',
  champs: {
    raisonSociale: 'Raison sociale', gerant: 'Gérant', rc: 'Registre de commerce',
    nif: "N° d'identification fiscale (NIF)", nis: "N° d'identification statistique (NIS)",
    articleImposition: "Article d'imposition", telephone: 'Téléphone', email: 'E-mail',
    adresse: 'Adresse', siteWeb: 'Site web',
  },
  tauxTva: 'Taux de TVA (%)',
  tauxTvaAide: '19 % en Algérie. Le taux est figé sur chaque facture au moment où elle est établie : changer ce chiffre ne réécrit jamais une facture déjà émise.',
  article01: 'Article 01 — age et qualification',
  ageMinimum: 'Age minimum',
  ageMinimumAide: 'Bloque la réservation en dessous.',
  anciennetePermis: 'Ancienneté de permis (ans)',
  rayon: (u: string) => `Rayon autorisé (${u})`,
  wilayas: 'Wilayas autorisées',
  regions: 'Régions autorisées',
  article02: 'Article 02 — horaires, et saisons',
  ouverture: 'Ouverture',
  fermeture: 'Fermeture',
  hauteDebut: 'Haute saison — début (MM-JJ)',
  hauteDebutAide: "L'ete. Le tarif haute saison de chaque voiture s'applique.",
  hauteFin: 'Haute saison — fin (MM-JJ)',
  preparation: 'Temps de preparation (min)',
  preparationAide: "Une voiture qui rentre à 11 h n'est pas libre à 11 h.",
  enregistrerRegles: 'Enregistrer les règles',
  suppSansPrixTitre: (n: number) => `${n} supplément(s) sans prix`,
  suppSansPrixTexte: "— ces prix ne figurent pas dans votre contrat, il faut les saisir ici pour qu'ils soient facturés.",
  catalogue: 'Catalogue unique — le siège bébé et le retard vivent dans la même liste',
  colonnes: { supplement: 'Supplément', arabe: 'Arabe', unite: 'Unité', moment: 'Moment', article: 'Article', prix: 'Prix' },
  suppNote: 'Les suppléments marqués « auto » sont proposés tout seuls au retour, avec leur formule. Modifier un prix ici ne change jamais un contrat déjà etabli.',
  cglTitre: 'Ces textes sont imprimés au verso du contrat',
  cglTexte1: 'Colonne gauche en francais, colonne droite en arabe. Les titres arabes sont deja saisis ;',
  cglTexte2: ' les corps de texte doivent être colles depuis votre contrat existant',
  cglTexte3: " — nous n'ecrivons pas de texte juridique arabe a votre place.",
  cglTexteIntl: (l1: string, l2: string) => l2
    ? `Colonne gauche : ${l1}. Colonne droite : ${l2}. Collez vos propres conditions — nous n'écrivons pas de texte juridique à votre place.`
    : `Une seule colonne : ${l1}. Collez vos propres conditions — nous n'écrivons pas de texte juridique à votre place.`,
  francais: 'Français',
  arabe: 'Arabe',
  languePrincipale: (l: string) => `Langue principale des documents (${l})`,
  langueSeconde: (l: string) => `Deuxième langue des documents (${l})`,
  arabeManquant: 'Texte arabe manquant — à coller depuis votre contrat',
  geoloc: 'Mention de géolocalisation',
  aColler: 'A coller depuis votre contrat',
  enregistrerCgl: 'Enregistrer les conditions générales',
  moment: { depart: 'Départ', retour: 'Retour' } as Record<string, string>,
  parUnite: (u: string) => `par ${u}`,
  art: (a: string) => `art. ${a}`,
  auto: 'auto',
};
